import axios from "axios";
import config from "../config";

// Solo se incluyen los JSON de mocks cuando config.mock.enabled esta activo.
const mockFiles = config.mock.enabled
    ? require.context("./mocks", true, /RS\.json$/)
    : null;

const isMockedService = (serviceName) =>
    !!(config.mock.enabled && mockFiles && config.mock.services[serviceName]);

const getMockResponse = (serviceName) => {
    const fileName = config.mock.services[serviceName];
    const mockPath = `./${config.mock.version}/${fileName}`;

    if (!mockFiles.keys().includes(mockPath)) {
        const error = new Error(`[MOCK] No existe el mock para "${serviceName}": src/util/mocks/${config.mock.version}/${fileName}`);
        console.error(error.message);
        throw error;
    }

    console.warn(`[MOCK] ${serviceName} -> src/util/mocks/${config.mock.version}/${fileName}`);

    // Se clona para que los reducers/transfers no muten el JSON importado entre llamadas.
    return {
        data: JSON.parse(JSON.stringify(mockFiles(mockPath))),
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        isMock: true
    };
};

// Ejecuta un POST contra config.services.reissue[serviceName], o devuelve su mock si está habilitado.
// Mantiene la forma de respuesta de axios ({ data, headers, ... }).
export const postService = async (serviceName, body, requestConfig) => {
    if (isMockedService(serviceName)) {
        return getMockResponse(serviceName);
    }

    const serviceUrl = config.services.reissue[serviceName];

    if (!serviceUrl) {
        throw new Error(`[SERVICE] No existe URL configurada para "${serviceName}"`);
    }

    return axios.post(serviceUrl, body, requestConfig);
};
